@if (loader$ | async; as loader) {
    <div class="dialog-overlay">
        <div class="dialog-overlay-content">
            <div class="loading-state absolute-center text-center">
                <div class="loading-state-spinner spinner spinner-lg"></div>
                <div class="loading-state-description margin-top-1">
                    {{ loader.loadingText | translate }}
                </div>
            </div>
        </div>
    </div>
}
